import React, { useMemo } from 'react';
import {
  useSubscriptions,
  useSubscriptionsDispatch,
} from '@features/subscriptions/context/subscription-context';
import { FlexView, Text } from '@goodfynd/ui';
import { renderPrice } from '@utils/number-util';

import { SubscriptionCheckoutItemActions } from './SubscriptionCheckoutItemActions';
import type { SubscriptionCheckoutItemProps } from './types';

export function SubscriptionCheckoutItem({
  item,
}: SubscriptionCheckoutItemProps) {
  const {
    cart: { frequency },
  } = useSubscriptions();
  const { findBySku } = useSubscriptionsDispatch();
  const product = useMemo(() => findBySku(item.sku), [findBySku, item.sku]);
  const price = useMemo(
    () =>
      (product?.prices.find((price) => price.frequency === frequency)?.price ||
        0) * item.newQuantity,
    [frequency, item.newQuantity, product?.prices]
  );

  if (!product || item.previousQuantity === item.quantity) {
    return null;
  }

  return (
    <FlexView fullWidth gap={16} justify="space-between">
      <FlexView direction="column">
        <Text>{product.name}</Text>
        <SubscriptionCheckoutItemActions
          allowMultiple={product.allowMultiple}
          item={item}
        />
      </FlexView>

      <Text>{renderPrice(price)}</Text>
    </FlexView>
  );
}
